// extracted by mini-css-extract-plugin
export var box = "CountCard-module--box--8c614";
export var box_md = "CountCard-module--box_md--6278d";
export var box_xmd = "CountCard-module--box_xmd--d89f9";
export var box_flex = "CountCard-module--box_flex--f5629";
export var box_lg = "CountCard-module--box_lg--adf01";
export var box_sm = "CountCard-module--box_sm--e5ac2";
export var box_outer = "CountCard-module--box_outer--88160";
export var box_whiteBg = "CountCard-module--box_white-bg--c6fff";
export var box_noMarginBottom = "CountCard-module--box_no-margin-bottom--f701c";
export var box_noPadding = "CountCard-module--box_no-padding--7b3e1";
export var box_outerGray = "CountCard-module--box_outer-gray--aea1d";
export var box_dark = "CountCard-module--box_dark--7b3b3";
export var box_zIndex = "CountCard-module--box_z-index--1bd73";
export var box_zIndex6 = "CountCard-module--box_z-index-6--2e0f6";
export var box_eventsWithLine = "CountCard-module--box_events-with-line--61848";
export var box_featuresAo = "CountCard-module--box_features-ao--e10b2";
export var box_verticalPaddings = "CountCard-module--box_vertical-paddings--4cfb0";
export var clearP = "CountCard-module--clearP--4fb59";
export var clearP_vc = "CountCard-module--clearP_vc--6d15b";
export var item = "CountCard-module--item--4aa69";
export var count = "CountCard-module--count--df146";
export var title = "CountCard-module--title--0b39e";
export var list = "CountCard-module--list--4eaca";
export var listItemTitle = "CountCard-module--listItemTitle--a3c42";
export var listItem = "CountCard-module--listItem--aeb08";
export var fadeInAnimation = "CountCard-module--fadeInAnimation--85af2";
export var placeHolderShimmer = "CountCard-module--placeHolderShimmer--503ae";